export default __webpack_public_path__ + "static/media/laval13.5e774388.jpg";